"use strict";

(function () {
  'use strict';

  angular.module('lr.reserve.billing-summary', []).component('lrReserveBillingSummary', {
    bindings: {
      transaction: '<',
      currencySymbol: '@',
      loading: '<',
      expanded: '@'
    },
    templateUrl: 'components/lr.reserve.billing-summary/lr.reserve.billing-summary.template.html'
  });
})();